import { gql } from '@moonpig/web-core-graphql'

export const GetRecipientsWithRemindersGQL = gql`
  query GetRecipientsWithReminders {
    me {
      recipients {
        items {
          id
          firstName
          lastName
        }
      }
    }
    reminders(input: {}) {
      recipientId
      relationship
    }
  }
`
